import { render, staticRenderFns } from "./InfoManagement.vue?vue&type=template&id=2e36b648&"
import script from "./InfoManagement.vue?vue&type=script&lang=js&"
export * from "./InfoManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports